function createParticipantsSummaryOverviewRowTaxableAccounts(summaryOverview) {
  const { totalPlans, totalParticipants, taxableAmount } = summaryOverview
  const pluralizedPlan = totalPlans === 1 ? 'plan' : 'plans'
  const pluralizedParticipant =
    totalParticipants === 1 ? 'participant' : 'participants'

  return {
    planName: `${totalPlans} ${pluralizedPlan}`,
    participants: `${totalParticipants} ${pluralizedParticipant}`,
    taxableAmount,
  }
}

export default createParticipantsSummaryOverviewRowTaxableAccounts
